import { render, staticRenderFns } from "./DisplayKindSpendeApp.vue?vue&type=template&id=760c28fa&scoped=true&"
import script from "./DisplayKindSpendeApp.vue?vue&type=script&lang=js&"
export * from "./DisplayKindSpendeApp.vue?vue&type=script&lang=js&"
import style0 from "./DisplayKindSpendeApp.vue?vue&type=style&index=0&id=760c28fa&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c28fa",
  null
  
)

export default component.exports